/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSelector } from "@reduxjs/toolkit";
import { selectCurrentModelType } from "../model";

/**
 * @typedef {import("./schema.state")["schemaState"]} SchemaState
 */

/**
 * @typedef {object} RootState
 * @property {SchemaState} schemas
 */

/**
 * @param {RootState} state
 */
export function selectAllSchemas (state) {
    return state.schemas.all || [];
}

/**
 * @param {RootState} state
 */
export function selectSchemasAreLoaded (state) {
    return state.schemas.all.length > 0;
}

export const selectCurrentModelSchema = createSelector(
    selectAllSchemas,
    selectCurrentModelType,
    (schemas, modelType) => {
        const schema = schemas.find(
            (element) => element.type === modelType
        );

        return schema;
    }
);

export const selectFieldSchema = createSelector(
    selectCurrentModelSchema,
    /**
     * @param {RootState} state 
     * @param {string} fieldName 
     */
    (state, fieldName) => fieldName,
    (schema, fieldName) => {
        const fields = schema.fields;
        return fields.find((item) => item.name === fieldName);       
    }
);

export const selectAllFieldSchemas = createSelector(
    selectCurrentModelSchema,
    (schema) => {
        return schema?.fields;
    }
);
